import { render, staticRenderFns } from "./ChooseAppearanceConstrain.vue?vue&type=template&id=5c5667cd&scoped=true"
import script from "./ChooseAppearanceConstrain.vue?vue&type=script&lang=js"
export * from "./ChooseAppearanceConstrain.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c5667cd",
  null
  
)

export default component.exports